import React, { type ReactNode } from 'react';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';

export const StorageManagementContextualAnalyticsData = ({ children }: { children: ReactNode }) => (
	<ContextualAnalyticsData sourceName="productsJswStorageManagement" sourceType={SCREEN}>
		{children}
		<FireScreenAnalytics />
	</ContextualAnalyticsData>
);
